/** Small line icons, one stroke weight, drawn inline so the feature needs no icon set. */
export const Icon = ({
   name,
   size = 18,
   className,
}: {
   name: string
   size?: number
   className?: string
}) => {
   const p = {
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 2,
      strokeLinecap: 'round' as const,
      strokeLinejoin: 'round' as const,
      className,
      'aria-hidden': true,
   }
   switch (name) {
      case 'check':
         return (
            <svg {...p}>
               <path d="M5 13l4 4L19 7" />
            </svg>
         )
      case 'chevrons':
         return (
            <svg {...p}>
               <path d="M6 5l7 7-7 7M13 5l7 7-7 7" />
            </svg>
         )
      case 'arrow-left':
         return (
            <svg {...p}>
               <path d="M19 12H5M11 6l-6 6 6 6" />
            </svg>
         )
      case 'arrow-right':
         return (
            <svg {...p}>
               <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
         )
      case 'phone':
         return (
            <svg {...p}>
               <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
            </svg>
         )
      case 'mail':
         return (
            <svg {...p}>
               <rect x="3" y="5" width="18" height="14" rx="2" />
               <path d="M3 7l9 6 9-6" />
            </svg>
         )
      case 'calendar':
         return (
            <svg {...p}>
               <rect x="3" y="5" width="18" height="16" rx="2" />
               <path d="M3 10h18M8 3v4M16 3v4" />
            </svg>
         )
      case 'message':
         return (
            <svg {...p}>
               <path d="M21 12a8 8 0 0 1-8 8H8l-5 3 1.2-4.5A8 8 0 1 1 21 12z" />
            </svg>
         )
      case 'pin':
         return (
            <svg {...p}>
               <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" />
               <circle cx="12" cy="10" r="2.5" />
            </svg>
         )
      case 'shield':
         return (
            <svg {...p}>
               <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
            </svg>
         )
      case 'users':
         return (
            <svg {...p}>
               <circle cx="9" cy="8" r="3.5" />
               <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4a3.5 3.5 0 0 1 0 7M21.5 20a6.5 6.5 0 0 0-4-6" />
            </svg>
         )
      case 'user':
         return (
            <svg {...p}>
               <circle cx="12" cy="8" r="4" />
               <path d="M4 21a8 8 0 0 1 16 0" />
            </svg>
         )
      case 'card':
         return (
            <svg {...p}>
               <rect x="2" y="5" width="20" height="14" rx="2" />
               <path d="M2 10h20M6 15h4" />
            </svg>
         )
      case 'gauge':
         return (
            <svg {...p}>
               <path d="M4 16a8 8 0 1 1 16 0" />
               <path d="M12 16l4-5" />
               <circle cx="12" cy="16" r="1.5" fill="currentColor" />
            </svg>
         )
      case 'file':
         return (
            <svg {...p}>
               <path d="M7 3h7l5 5v13H7z" />
               <path d="M14 3v5h5M10 13h6M10 17h6" />
            </svg>
         )
      case 'key':
         return (
            <svg {...p}>
               <circle cx="8" cy="12" r="4" />
               <path d="M12 12h9M18 12v3M15 12v2" />
            </svg>
         )
      case 'lock':
         return (
            <svg {...p}>
               <rect x="4" y="11" width="16" height="10" rx="2" />
               <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
         )
      case 'close':
         return (
            <svg {...p}>
               <path d="M6 6l12 12M18 6L6 18" />
            </svg>
         )
      case 'plus':
         return (
            <svg {...p}>
               <path d="M12 5v14M5 12h14" />
            </svg>
         )
      case 'search':
         return (
            <svg {...p}>
               <circle cx="11" cy="11" r="7" />
               <path d="M20 20l-3.5-3.5" />
            </svg>
         )
      case 'power':
         return (
            <svg {...p}>
               <path d="M12 3v9M18.4 6.6a9 9 0 1 1-12.8 0" />
            </svg>
         )
      case 'building':
         return (
            <svg {...p}>
               <rect x="4" y="3" width="16" height="18" rx="2" />
               <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3" />
            </svg>
         )
      case 'alert':
         return (
            <svg {...p}>
               <path d="M12 9v4M12 17h.01M10.3 3.9L2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
            </svg>
         )
      case 'download':
         return (
            <svg {...p}>
               <path d="M12 4v12M7 11l5 5 5-5M4 20h16" />
            </svg>
         )
      default:
         return null
   }
}

export const GoogleG = () => (
   <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path
         fill="#EA4335"
         d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6C12.3 13.5 17.7 9.5 24 9.5z"
      />
      <path
         fill="#4285F4"
         d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"
      />
      <path
         fill="#FBBC05"
         d="M10.4 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.8-6C.9 16.5 0 20.1 0 24s.9 7.5 2.6 10.7l7.8-6z"
      />
      <path
         fill="#34A853"
         d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.3-7.9 2.3-6.3 0-11.7-4-13.6-9.6l-7.8 6C6.5 42.6 14.6 48 24 48z"
      />
   </svg>
)

export const MicrosoftM = () => (
   <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="2" y="2" width="9" height="9" fill="#F25022" />
      <rect x="13" y="2" width="9" height="9" fill="#7FBA00" />
      <rect x="2" y="13" width="9" height="9" fill="#00A4EF" />
      <rect x="13" y="13" width="9" height="9" fill="#FFB900" />
   </svg>
)
